// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CategorizedRealizationList_wrapper__F_dEm","loadMore":"CategorizedRealizationList_loadMore__jfYf_"};